
import './style.scss'
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
// import { userStateData } from '../../data/userStateData';
import { setDataLoadRequestFinished } from '../../redux/reducers/userSlice';
import { setSubPage } from '../../redux/reducers/dashboardSlice';
import { DashboardSubPages } from '../../types/types';
import { adminConnector } from '../../server/connector/adminConnector';
import AdminSideMenu from '../../sections/adminSideMenu/AdminSideMenu';
import AdminInstructorsContentArea from '../../sections/adminInstructorsContentArea/AdminInstructorsContentArea';
import AdminHeader from '../../sections/adminHeader/AdminHeader';
import { useCookies } from 'react-cookie';
import { adminStateData } from '../../data/adminStateData';
import { PAGE_URLS } from '../../constants/hrefLinks';

function AdminInstructors() {
	const loginChecked: boolean = useAppSelector(state => state.user.loginChecked)
	const dispatch = useAppDispatch()
	const [cookies] = useCookies()

	useEffect(() => {
		// set subpage for side menu highlighting
		// dispatch(setSubPage(DashboardSubPages.MAIN))
		// // check if log in has been checked and confirmed in App.tsx
		// if (loginChecked == true) {
		// 	// confirm a user is logged in
		// 	if (userStateData.loggedIn == false) {
		// 		window.location.replace('/')
		// 	} else {
		// 		// Load user data such as interactions data
		// 		loadProfileData()
		// 	}
		// }
		dispatch(setSubPage(DashboardSubPages.INSTRUCTORS))
		// check if log in has been checked and confirmed in App.tsx
		if (cookies?.adminLogin) {
			adminStateData.loggedIn = cookies?.adminLogin
			loadProfileData()
		} else {
			window.location.replace(PAGE_URLS.ADMIN_LOGIN)
		}
	}, [loginChecked])

	const loadProfileData = () => {
		if (adminConnector.requestInProgress) {
			console.log('[Dashboard] - loadProfileData() called while requestInProgress')
		} else {
			adminConnector.performGetAdminInstructorsRequest().then((requestStatus) => {
				if (!requestStatus) {
					console.log('WARNING - [Admin] - performGetAdminCustomersRequest() failed')
				}
				dispatch(setDataLoadRequestFinished(true))
			})
		}
	}

	return (
		<div className='dashboard-wrap'>
			{loginChecked &&
				<>
					<AdminSideMenu />
					<div
						className='dashboard-content-wrap'
					>
						<AdminHeader title='Admin - Instructors' />
						<AdminInstructorsContentArea />
					</div>
				</>
			}
		</div>
	)
}

export default AdminInstructors
